module.exports = __webpack_public_path__ + "static/media/PERMIT Beijing.c0431a01.jpeg";